/**
 * Endereços do YouTube: o código do vídeo (11 caracteres), o player sem cookie e
 * as miniaturas. Aceita watch?v=, youtu.be/, embed/, shorts/, live/ e o domínio
 * youtube-nocookie.
 */
const PADRAO =
  /(?:youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/;

export const codigoDoVideo = (url) => (url || '').match(PADRAO)?.[1] || null;

export const enderecoDoPlayer = (codigo) =>
  `https://www.youtube-nocookie.com/embed/${codigo}?autoplay=1&rel=0`;

export const miniatura = (codigo, tamanho = 'maxresdefault') =>
  `https://i.ytimg.com/vi/${codigo}/${tamanho}.jpg`;

export const enderecoCanonico = (codigo) =>
  `https://www.youtube.com/watch?v=${codigo}`;

/** Título do vídeo pelo oEmbed do YouTube (aceita chamada do navegador). */
export const buscarTitulo = async (codigo, buscar = fetch) => {
  const r = await buscar(
    `https://www.youtube.com/oembed?format=json&url=${encodeURIComponent(
      enderecoCanonico(codigo),
    )}`,
  );
  if (!r.ok) return null;
  const j = await r.json();
  return (j?.title || '').trim() || null;
};
